import type { ToastType } from '../contexts/toast-hooks';
import { TOAST_EVENT, CONFIRM_EVENT } from '../contexts/toast-events';

export const showToast = (message: string, type: ToastType = 'info') => {
    window.dispatchEvent(new CustomEvent(TOAST_EVENT, { detail: { message, type } }));
};

export const confirmDialog = (message: string, confirmText = 'Confirm', cancelText = 'Cancel'): Promise<boolean> => new Promise((resolve) => {
        window.dispatchEvent(new CustomEvent(CONFIRM_EVENT, { 
            detail: { message, confirmText, cancelText, resolve } 
        }));
    });














